import { useEffect, useState } from "react"
import { APIS } from "../../../config/apis"
import { REQUEST_METHOD } from '@laramie/ui';
import { ServerRequest } from "../../../utils/apiweb"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { isValidNumber, isNull } from "../../../utils/validator"
import { Modal, FormLabel, FormError } from "../../common"
import { useForm, useManagedContext, useFormErrors } from "../../hooks"
import {TIPS} from "../../../consts/tips";
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const entityInit = {
    id: -1,
    codigo: '',
    nombre: '',
    orden: '',
    esPlan: false,
    esDerechoEspontaneo: false,
}

const CategoriaTasaModal = (props) => {
    const { setIsLoading } = useManagedContext()

    const [entity, setEntity] = useState(entityInit)
    const [formValues, formHandle, _, formSet] = useForm({
        codigo: '',
        nombre: '',
        orden: '',
        esPlan: false,
        esDerechoEspontaneo: false,
    })

    useEffect(() => {
        const { codigo, nombre, orden, esPlan, esDerechoEspontaneo } = props.item
        setEntity({ ...entityInit, ...props.item })
        formSet({ codigo, nombre, orden, esPlan, esDerechoEspontaneo })
    }, [props.item])

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    const onConfirm = () => {
        if (!validate()) return

        setIsLoading(true)

        ServerRequest(
            props.editMode === 'add' ? REQUEST_METHOD.POST : REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CATEGORIA_TASA,
            props.editMode === 'modify' ? `/${entity.id}` : '',
            {...entity, ...formValues, orden: parseInt(formValues.orden) ?? 0},
            res => res.json().then(() => {
                setIsLoading(false)
                props.onConfirm()
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            error => {
                onRequestError(error)
                setIsLoading(false)
            },
        )
    }

    function getErrors() {
        const errors = {}

        if (formValues.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED
        if (formValues.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED

        return errors
    }

    function getFormatErrors() {
        const errors = {}
        if (props.editMode === 'view') return errors

        if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero'

        return errors
    }

    function isEmptyValue(valor) {
        return isNull(valor) || valor.toString().length === 0
    }

    const disabled = props.editMode === 'view'

    return (
        <Modal
            onEscape={props.onCancel}
            size="md"
            title="Categoría de tasa"
            tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            body={(
                <div className="row form-basic">
                    <div className="col-12 col-md-3">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            type="text"
                            name="codigo"
                            maxLength={50}
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-6">
                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                        <input
                            type="text"
                            name="nombre"
                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                            value={formValues.nombre}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('nombre')} />
                    </div>
                    <div className="col-12 col-md-3">
                        <FormLabel htmlFor="orden" required>Orden</FormLabel>
                        <input
                          name="orden"
						  type="number"
						  placeholder=""
						  className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
						  value={formValues.orden}
						  onChange={formHandle}
						  disabled={disabled}
                        />
                        <FormError message={errorOf('orden')} />
                    </div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={props.onCancel}>Volver</button>
                    {props.editMode !== 'view' && (
                        <button className="btn action-button" data-dismiss="modal" onClick={() => onConfirm()}>Guardar</button>
                    )}
                </div>
            )}
        />
    )
}

export default CategoriaTasaModal
